import { UUID } from "./uuid";

// 30 mins
const SESSION_DURATION = 30 * 60 * 1000;

// Session information
let sessionInfo = {
  sessionID: null,
  sessionStart: null,
};

function isBot() {
  const userAgent = navigator.userAgent.toLowerCase();
  const knownBots = [
    /bot/i,
    /crawler/i,
    /spider/i,
    /crawling/i,
    /preview/i,
    /scan/i,
    /slurp/i,
    /facebookexternalhit/i,
    /pingdom/i,
    /monitor/i,
  ];

  const isBot = knownBots.some((botRegex) => botRegex.test(userAgent));
  const isHeadless = navigator.webdriver === true;

  return isBot || isHeadless;
}

// Function to check if the session has expired
function hasSessionExpired() {
  if (!sessionInfo.sessionStart) return true; // No session start, session expired

  const sessionStartTime = new Date(sessionInfo.sessionStart).getTime();
  const currentTime = new Date().getTime();
  return currentTime - sessionStartTime > SESSION_DURATION;
}

// Initialize session logic
export function initAnalytics() {
  if (hasSessionExpired()) {
    sessionInfo.sessionID = UUID.generate();
    sessionInfo.sessionStart = new Date().toISOString();
  }
}

function ignoreAnalytics() {
  return document.cookie.includes("ignore_analytics=true");
}

export async function logNavigation(path) {
  // Ignore if localhost or iframe
  if (
    ignoreAnalytics() ||
    window.location.href.startsWith("https://storefront.local") ||
    window.location.href.includes("localhost")
  ) {
    console.log("[Analytics] Dev URL – analytics not logged.", path);
    return;
  }

  // Skip logging if this is likely a bot
  if (isBot()) {
    return;
  }

  // Initialize session if necessary
  if (!sessionInfo.sessionID) {
    initAnalytics();
  }

  const analyticsData = {
    time: new Date().toISOString(),
    page: path,
    referrer: document.referrer || null,
    metadata: {
      userAgent: navigator.userAgent,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      language: navigator.language,
      url: window.location.href,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };

  try {
    const response = await fetch("/api/event", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(analyticsData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error posting data:", error);
  }
}
